<template>
	<div class="page-subtitle">Позиции</div>
	<div class="table-card table-card--form">
		<div class="table-card__positions table-wrap" v-if="positions?.size">
			<table class="table table--default">
				<thead class="table__head">
				<tr class="table__row table__row--index">
					<td class="table__col">№</td>
					<td class="table__col">Наименование товара</td>
					<td class="table__col">Артикул ЕТУ</td>
					<td class="table__col">Объем партии,<br> Единица измерения</td>
					<td class="table__col">
						<template v-if="!itsCO">
							Стартовая цена
						</template>
					</td>
					<td class="table__col">Срок поставки с</td>
					<td class="table__col">Срок поставки до</td>
					<td class="table__col">Описание товара</td>
				</tr>
				<tr class="table__margin">
					<td colspan="100%"></td>
				</tr>
				</thead>
				<tbody  class="table__body">
				<template v-for="item in positions" :key="item">
					<tr class="table__row table__row--index">
						<td class="table__col">
							<span class="table__col-label">№</span>
							<span class="table__col-cont">{{ item.product }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Наименование товара</span>
							<span class="table__col-cont">{{ item.name }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Артикул ЕТУ</span>
							<span class="table__col-cont">{{ item.vendor || '-'}}</span>
						</td>
						<td class="table__col nowrap">
							<span class="table__col-label">Объем партии, Единица измерения</span>
							<span class="table__col-cont">
									<div class="unit-measurement">
										<InputText placeholder="1" :cost="true"  v-model="item.lotSize"/>
										<div class="unit-measurement__bage">
											{{getProductsUnits.find(obj => obj.id === item.unit).name}}
										</div>
									</div>
								</span>
						</td>
						<td class="table__col">
							<template v-if="!itsCO">
								<span class="table__col-label">Стартовая цена</span>
								<span class="table__col-cont">
										<div class="unit-measurement">
											<InputText :placeholder="'1 000'" :cost="true" v-model="item.startPrice"/>
											<div class="unit-measurement__bage">₽</div>
										</div>
									</span>
							</template>
						</td>
						<td class="table__col nowrap">
							<span class="table__col-label">Срок поставки с </span>
							<span class="table__col-cont">
									<div class="unit-measurement">
										<InputDate v-model="item.supplyTimeFrom" placeholder="xx.xx.xxxx"/>
									</div>
								</span>
						</td>
						<td class="table__col nowrap">
							<span class="table__col-label">Срок поставки до</span>
							<span class="table__col-cont">
									<div class="unit-measurement">
										<InputDate v-model="item.supplyTimeTo" placeholder="xx.xx.xxxx"/>
									</div>
								</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Описание товара</span>
							<span class="table__col-cont">
									<span class="line">
										<InputText :placeholder="'Краткое описание'" v-model="item.description" />
										<span class="copy" @click="copyPosition(item)"></span>
										<span class="delete" @click="deletePosition(item)"></span>
									</span>
								</span>
						</td>
					</tr>
					<tr class="table__margin">
						<td colspan="100%"></td>
					</tr>
				</template>
				</tbody>
			</table>
		</div>
		<div class="table-card__btns">
			<button class="table-btn btn btn--color" @click="ShowAddPositionPopup = true">Добавить позицию</button>
			<button v-if="itsCO" class="table-btn btn btn--color" @click="ShowAddEtuPopup = true">Добавить ЕТУ</button>
		</div>
	</div>
	<transition name="modal">
		<AddPositionPopup
			v-if="ShowAddPositionPopup"
			@close="ShowAddPositionPopup = false"
			v-model="listPositions"/>
	</transition>
	<transition name="modal">
		<AddEtuPopup
			v-if="ShowAddEtuPopup"
			@close="ShowAddEtuPopup = false"
			v-model="listPositions"
		/>
	</transition>
</template>

<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputDate from "@/components/base/utils/formElements/InputDate.vue";
import AddPositionPopup from "@/components/sections/Tenders/CreateEditTender/AddPositionPopup.vue";
import AddEtuPopup from "@/components/sections/Tenders/CreateEditTender/AddEtuPopup.vue";
import {mapActions, mapGetters} from "vuex";
import moment from 'moment';
import useVuelidate from "@vuelidate/core";


export default {
	inheritAttrs:false,
	name: "TenderTable",
	components: {InputText,AddPositionPopup, AddEtuPopup, InputDate},
	emits: ['update:modelValue'],
	props: {
		itsCO: {
			type: Boolean,
			default: false
		}
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	async created() {
		await this.requestProductsUnits();
	},
	data() {
		return {
			ShowAddPositionPopup: false,
			ShowAddEtuPopup: false,
			listPositions: [],
			positions: new Set()
		}
	},
	methods: {
		deletePosition(item) {
			this.positions.delete(item)
		},
		copyPosition(item) {
			const map = {
				name: item.name,
				product: item.product,
				vendor: item.vendor,
				lotSize: item.lotSize,
				unit: item.unit,
				startPrice: item.startPrice,
				description: item.description,
				supplyTimeFrom: [moment(item.supplyTimeFrom[0]).toDate()],
				supplyTimeTo: [moment(item.supplyTimeTo[0]).toDate()]
			}
			this.positions.add(map)
		},
		updatePositions() {
			this.$emit('update:modelValue', Array.from(this.positions))
		},

		mapPositions() {
		console.log('map', this.listPositions)
			this.listPositions?.map(item => {
				console.log(item.supplyTimeFrom)
				const map = {
					name: item.name,
					product: item.id,
					vendor: item.vendor,
					lotSize: '1',
					unit: item.unit.id,
					startPrice: '',
					description: '',
					supplyTimeFrom: [item.supplyTimeFrom ? moment(item.supplyTimeFrom, "DD.MM.YYYY HH:mm").toDate() : ''],
					supplyTimeTo: [item.supplyTimeTo ? moment(item.supplyTimeTo, "DD.MM.YYYY HH:mm").toDate() : ''],
				}

				this.positions.add(map)
			})
		},
		fillPositions(array) {
			array?.map(item => {
				let map  = {
					name: item.product.name,
					product: item.product.id,
					vendor: item.product.vendor,
					lotSize: String(item.lotSize).replace(/\s/g, ""),
					unit: item.product.unit.id,
					startPrice: String(item.startPrice),
					description: item.description,
					supplyTimeFrom: [item.supplyTimeFrom ? moment(item.supplyTimeFrom, "DD.MM.YYYY HH:mm").toDate() : ''],
					supplyTimeTo: [item.supplyTimeTo ? moment(item.supplyTimeTo, "DD.MM.YYYY HH:mm").toDate() : ''],
				}
				this.positions.add(map)
			})
			this.updatePositions()
		},


		...mapActions({
			requestProductsUnits: 'products/requestProductsUnits',
		})
	},
	computed: {
		...mapGetters({
			getProductsUnits: 'products/getProductsUnits',
		})
	},
	watch: {
		ShowAddEtuPopup(value) {
			if(value) return
			this.mapPositions()
		},
		ShowAddPositionPopup(value) {
			if(value) return
			this.mapPositions()
		},
	}
}
</script>


